import { thor } from "../typings/thor";
import { SearchService } from "../core/search/service";

/*
 * @TODO : to be refactored in a more agnostic approach:
 * - content type (sales, items) & context (future, past) should pass as parameters
 * - all the following public methods should be merged into a single one
 */
class LokiSearchService extends SearchService {
    public searchFutureSales(
        filterParams: thor.SearchFilterParams = {},
        _,
        call: number = 0,
        pagination = this.paginationDefault
    ): Promise<thor.SaleGet[]> {
        return this._searchSales(filterParams, call, pagination);
    }

    public searchPastSales(
        filterParams: thor.SearchFilterParams = {},
        _,
        call: number = 0,
        pagination = this.paginationDefault
    ): Promise<thor.SaleGet[]> {
        return this._searchSales(filterParams, call, pagination, true);
    }

    public searchFutureItems(
        filterParams: thor.SearchFilterParams = {},
        sortParams: any = {},
        call: number = 0,
        pagination = this.paginationDefault
    ): Promise<thor.ItemGet[]> {
        return this._searchItems(filterParams, sortParams, call, pagination);
    }

    public searchPastItems(
        filterParams: thor.SearchFilterParams = {},
        sortParams: any = {},
        call: number = 0,
        pagination = this.paginationDefault
    ): Promise<thor.ItemGet[]> {
        return this._searchItems(filterParams, sortParams, call, pagination, true);
    }

    private _searchSales(
        filterParams: thor.SearchFilterParams,
        call: number,
        pagination: number,
        past: boolean = false
    ): Promise<thor.SaleGet[]> {
        const params = {
            type: `thor_${past ? "past" : "future"}_sales`,
            "filters[organization]": this.authService.getOrganizationId(),
            "filters[deleted]": 0,
            sort: "-datetime,address.postcode"
        };
        if (!past) {
            params["filters[date]"] = 1;
        }
        const queryParams = this.formatSaleQueryParams(params, filterParams);

        return call >= 0 ? this.search(queryParams, call, pagination) : this.query(queryParams, pagination);
    }

    private _searchItems(
        filterParams: thor.SearchFilterParams,
        sortParams: any,
        call: number,
        pagination: number,
        past: boolean = false
    ): Promise<thor.ItemGet[]> {
        const params = {
            type: `thor_${past ? "past" : "future"}_items`,
            "filters[hidden]": 0
        };
        if (past) {
            params["filters[suppressed]"] = 0;
        }
        const queryParams = this.formatItemsQueryParams(params, filterParams);

        if (sortParams.field) {
            let sort = sortParams.field;
            if (sortParams.reverse) {
                sort = "-" + sort;
            }
            queryParams.sort = sort;
        }
        return this.search(queryParams, call, pagination);
    }
}

angular
    .module("thor.loki.search.service", [])
    .service("lokiSearchService", LokiSearchService);
